export const MODAL_CONFIRM_BUTTON_LABEL = "übernehmen";